import { useUnsplashImages } from 'hooks/queries/useUnsplashImages'
import { Preview, SuggestedCategoryProps } from './Types'
import { SuggestedCategory } from './SuggestedCategory'

interface Props extends Omit<SuggestedCategoryProps, 'previews' | 'onExpand'> {
  seeds?: Array<Preview>
  onExpand: (query: string, seeds?: Preview[]) => any
}

export const UnsplashSuggestedCategory = ({ name, seeds = [], onExpand }: Props) => {
  const { data } = useUnsplashImages({ query: name, perPage: 4 })

  const unsplashResults = (data?.pages || []).flatMap((page) =>
    page?.type === 'success' ? page.data.results ?? [] : [],
  )
  const previews = [
    ...seeds,
    ...unsplashResults.map((result) => ({
      src: result.urls.thumb,
      alt: result.alt_description || '',
      width: result.width,
      height: result.height,
    })),
  ].slice(0, 4)

  return <SuggestedCategory name={name} previews={previews} onExpand={(name) => onExpand(name, seeds)} />
}
